import { render } from "./ActivityProductTemplate.vue?vue&type=template&id=a7f9a7e6&scoped=true"
import script from "./ActivityProductTemplate.vue?vue&type=script&lang=js"
export * from "./ActivityProductTemplate.vue?vue&type=script&lang=js"

import "./ActivityProductTemplate.vue?vue&type=style&index=0&id=a7f9a7e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7f9a7e6"]])

export default __exports__